import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { FormInput, Hint, Tooltip } from '@systemeio/ui';
import { getServerSideFlagsProps } from 'growthbook/server';
import { FlagsPropsType } from 'growthbook/types';
import { activateCourseBundle, createCourseBundle, removeCourseBundle, updateCourseBundle } from 'modules/courses/bundles/api/course-bundles-api';
import { CourseBundlesLoco } from 'modules/courses/bundles/constants/course-bundles-loco';
import { useCourseBundles } from 'modules/courses/bundles/hooks/use-course-bundles';
import { CourseBundleCreateInterface, CourseBundleErrorsInterface, CourseBundleItemInterface } from 'modules/courses/bundles/types/course-bundle-interface';
import TabMenu from 'modules/courses/components/tab-menu';
import { NextPage } from 'next';
import { useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { CreateDataType } from 'shared/components/create-modal';
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps, getCombinedServerSideProps } from 'shared/utils/get-base-server-side-props';
import { CheckCircleIcon } from '@systemeio/ui/icons';
const defaultValues: CourseBundleCreateInterface = {
  name: '',
  description: '',
  instructorName: '',
  image: null
};
const defaultErrors: CourseBundleErrorsInterface = {
  name: '',
  description: '',
  instructorName: '',
  image: ''
};
const CourseBundles: NextPage<FlagsPropsType> = () => {
  const $ = _c(141);
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  const [errors, setErrors] = useState(defaultErrors);
  let t0;
  if ($[0] !== limit || $[1] !== pagination) {
    t0 = {
      limit,
      pagination
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    courseBundles,
    mutate,
    counter
  } = useCourseBundles(t0);
  const {
    revalidateModules
  } = useRevalidateModules();
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[3] !== t) {
    t1 = t("global.title");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      key: "name",
      header: t1,
      widthPercent: 30,
      onRender: _temp
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("dashboard.course_bundle.cover_title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = {
      key: "cover",
      header: t3,
      widthPercent: 30,
      onRender: _temp2
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("global.description");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = {
      key: "description",
      header: t5,
      widthPercent: 40
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("dashboard.course.instructor_name_title");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = {
      key: "instructorName",
      header: t7,
      widthPercent: 20
    };
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("global.status");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = courseBundle_0 => <div className="flex items-center lg:ml-4"><Tooltip label={courseBundle_0.deactivatedAt ? t("global.inactive") : t("global.active")} mode="hover" key="status-tooltip"><CheckCircleIcon className={`h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] ${!courseBundle_0.deactivatedAt && "fill-green"}`} /></Tooltip></div>;
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = {
      key: "active",
      header: t9,
      widthPercent: 15,
      onRender: t10
    };
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t2 || $[28] !== t4 || $[29] !== t6 || $[30] !== t8) {
    t12 = [t2, t4, t6, t8, t11];
    $[26] = t11;
    $[27] = t2;
    $[28] = t4;
    $[29] = t6;
    $[30] = t8;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const columns = t12;
  let t13;
  if ($[32] !== mutate || $[33] !== revalidateModules) {
    t13 = async courseBundle_1 => {
      const update = courseBundle_1.deactivatedAt ? "activate" : "deactivate";
      await activateCourseBundle(update, courseBundle_1.id);
      await mutate(data => {
        if (data) {
          return {
            items: data.items.map(item => {
              if (item.id === courseBundle_1.id) {
                item = {
                  ...item,
                  deactivatedAt: item.deactivatedAt ? null : "deactivated"
                };
              }
              return item;
            }),
            hasMore: data.hasMore
          };
        }
      }, false);
      await revalidateModules([RequestModuleEnum.CourseBundle]);
    };
    $[32] = mutate;
    $[33] = revalidateModules;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const onActivateCourseBundle = t13;
  let t14;
  if ($[35] !== revalidateModules) {
    t14 = async courseBundle_2 => {
      await removeCourseBundle(courseBundle_2.id);
      await revalidateModules([RequestModuleEnum.CourseBundle], true);
    };
    $[35] = revalidateModules;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  const onRemoveCourseBundle = t14;
  let t15;
  if ($[37] !== revalidateModules) {
    t15 = async data_0 => {
      await fetchWithErrors(async () => {
        await createCourseBundle({
          name: data_0.name,
          description: data_0.description,
          instructorName: data_0.instructorName,
          image: data_0.image?.id || null
        });
        await revalidateModules([RequestModuleEnum.CourseBundle], true);
      }, setErrors);
    };
    $[37] = revalidateModules;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const onCreateCourseBundle = t15;
  let t16;
  if ($[39] !== mutate || $[40] !== revalidateModules) {
    t16 = async (courseBundle_3, data_1) => {
      await fetchWithErrors(async () => {
        const response = await updateCourseBundle(courseBundle_3.id, {
          name: data_1.name,
          description: data_1.description,
          instructorName: data_1.instructorName,
          image: data_1.image?.id || null
        });
        await mutate(data_2 => {
          if (data_2) {
            return {
              items: data_2.items.map(item_0 => {
                if (item_0.id === courseBundle_3.id) {
                  item_0 = response.data;
                }
                return item_0;
              }),
              hasMore: data_2.hasMore
            };
          }
        }, false);
        await revalidateModules([RequestModuleEnum.CourseBundle]);
      }, setErrors);
    };
    $[39] = mutate;
    $[40] = revalidateModules;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const onEditCourseBundle = t16;
  let t17;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setErrors(defaultErrors);
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  const onModalClose = t17;
  let t18;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <TabMenu />;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  const t19 = counter?.count || 1;
  let t20;
  if ($[44] !== t || $[45] !== t19) {
    t20 = t("dashboard.bundles.title", {
      count: t19
    });
    $[44] = t;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t) {
    t21 = t("dashboard.course_bundle.title_one");
    $[47] = t;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["name"];
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== onCreateCourseBundle) {
    t23 = data_3 => onCreateCourseBundle(data_3);
    $[50] = onCreateCourseBundle;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== errors || $[53] !== t) {
    t24 = {
      field: "name",
      onRender: (value, onChange) => <FormInput key="course-bundle-name-create" value={value} label={t("global.name")} onChange={e => {
        onChange(e.target.value);
      }} maxLength={255} error={errors.name} />
    };
    $[52] = errors;
    $[53] = t;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== errors || $[56] !== t) {
    t25 = {
      field: "description",
      onRender: (value_0, onChange_0) => <FormInput key="course-bundle-description-create" value={value_0 || ""} onChange={e_0 => onChange_0(e_0.target.value)} error={errors.name} label={t("global.description")} />
    };
    $[55] = errors;
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== errors || $[59] !== t) {
    t26 = {
      field: "instructorName",
      onRender: (value_1, onChange_1) => <FormInput key="course-bundle-name-create" value={value_1 || ""} onChange={e_1 => onChange_1(e_1.target.value)} error={errors.name} label={t("dashboard.course.instructor_name_title")} />
    };
    $[58] = errors;
    $[59] = t;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  let t27;
  if ($[61] !== t) {
    t27 = {
      field: "image",
      onRender: (value_2, onChange_2) => <ImageUploaderWithPreviewImage key="course-bundle-image-create" label={<Hint label={t("dashboard.course.image_popover_title")}>{t("dashboard.course_bundle.cover_title")}</Hint>} previewClassName="h-[200px] w-[364px]" value={value_2} onRemove={() => {
        onChange_2(null);
      }} onSelect={onChange_2} aspectRatio={1.7777777777777777} source={FileSourceEnum.Membership} />
    };
    $[61] = t;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== t24 || $[64] !== t25 || $[65] !== t26 || $[66] !== t27) {
    t28 = [t24, t25, t26, t27];
    $[63] = t24;
    $[64] = t25;
    $[65] = t26;
    $[66] = t27;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t21 || $[69] !== t23 || $[70] !== t28) {
    t29 = {
      caption: t21,
      onAfterLeave: onModalClose,
      defaultValues,
      requiredFields: t22,
      onCreate: t23,
      creatable: t28
    };
    $[68] = t21;
    $[69] = t23;
    $[70] = t28;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== t) {
    t30 = t("dashboard.course_bundle.title_one");
    $[72] = t;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  let t31;
  if ($[74] !== limit || $[75] !== setLimit) {
    t31 = {
      limit,
      setLimit
    };
    $[74] = limit;
    $[75] = setLimit;
    $[76] = t31;
  } else {
    t31 = $[76];
  }
  let t32;
  if ($[77] !== pagination || $[78] !== setPagination) {
    t32 = {
      pagination,
      setPagination
    };
    $[77] = pagination;
    $[78] = setPagination;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = [{
      name: "view-course-bundle",
      openInNew: false,
      setHref: _temp3,
      isNext: true
    }];
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[81] !== onEditCourseBundle) {
    t34 = (courseBundle_5, data_4) => onEditCourseBundle(courseBundle_5, data_4);
    $[81] = onEditCourseBundle;
    $[82] = t34;
  } else {
    t34 = $[82];
  }
  let t35;
  if ($[83] !== errors || $[84] !== t) {
    t35 = {
      field: "name",
      onRender: (value_3, onChange_3) => <FormInput key="course-bundle-name-edit" value={value_3} onChange={e_2 => onChange_3(e_2.target.value)} error={errors.name} label={t("global.name")} />
    };
    $[83] = errors;
    $[84] = t;
    $[85] = t35;
  } else {
    t35 = $[85];
  }
  let t36;
  if ($[86] !== errors || $[87] !== t) {
    t36 = {
      field: "description",
      onRender: (value_4, onChange_4) => <FormInput key="course-bundle-description-edit" value={value_4 || ""} onChange={e_3 => onChange_4(e_3.target.value)} error={errors.description} label={t("global.description")} />
    };
    $[86] = errors;
    $[87] = t;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  let t37;
  if ($[89] !== errors || $[90] !== t) {
    t37 = {
      field: "instructorName",
      onRender: (value_5, onChange_5) => <FormInput key="course-bundle-instructor-name-edit" value={value_5 || ""} onChange={e_4 => onChange_5(e_4.target.value)} error={errors.instructorName} label={t("dashboard.course.instructor_name_title")} />
    };
    $[89] = errors;
    $[90] = t;
    $[91] = t37;
  } else {
    t37 = $[91];
  }
  let t38;
  if ($[92] !== errors || $[93] !== t) {
    t38 = {
      field: "image",
      onRender: (value_6, onChange_6) => <ImageUploaderWithPreviewImage key="course-bundle-image-edit" label={<Hint label={t("dashboard.course.image_popover_title")}>{t("dashboard.course_bundle.cover_title")}</Hint>} value={value_6} onRemove={() => {
        onChange_6(null);
      }} onSelect={onChange_6} aspectRatio={1.7777777777777777} source={FileSourceEnum.Membership} previewClassName="h-[200px] w-[364px]" error={errors.image} />
    };
    $[92] = errors;
    $[93] = t;
    $[94] = t38;
  } else {
    t38 = $[94];
  }
  let t39;
  if ($[95] !== t35 || $[96] !== t36 || $[97] !== t37 || $[98] !== t38) {
    t39 = [t35, t36, t37, t38];
    $[95] = t35;
    $[96] = t36;
    $[97] = t37;
    $[98] = t38;
    $[99] = t39;
  } else {
    t39 = $[99];
  }
  let t40;
  if ($[100] !== t34 || $[101] !== t39) {
    t40 = {
      onModalClose,
      onEdit: t34,
      editable: t39
    };
    $[100] = t34;
    $[101] = t39;
    $[102] = t40;
  } else {
    t40 = $[102];
  }
  let t41;
  if ($[103] !== t) {
    t41 = t("dashboard.actions.title.activate");
    $[103] = t;
    $[104] = t41;
  } else {
    t41 = $[104];
  }
  let t42;
  if ($[105] !== onActivateCourseBundle || $[106] !== t) {
    t42 = (opened, onClose, courseBundle_7, key) => <Confirmation key={key} opened={opened} onClose={onClose} onConfirm={() => onActivateCourseBundle(courseBundle_7)} confirmationText={t("dashboard.actions.activate_confirmation", {
      activate: t("global.activate").toLowerCase(),
      module: t("dashboard.course_bundle.title_one").toLowerCase()
    })} toastCaption={t("dashboard.actions.activated", {
      module: t("dashboard.course_bundle.title_one"),
      activated: t("dashboard.actions.activated_caption").toLowerCase()
    })} />;
    $[105] = onActivateCourseBundle;
    $[106] = t;
    $[107] = t42;
  } else {
    t42 = $[107];
  }
  let t43;
  if ($[108] !== t41 || $[109] !== t42) {
    t43 = {
      name: "activate-course-bundle",
      shouldRender: _temp4,
      caption: t41,
      onActionRender: t42
    };
    $[108] = t41;
    $[109] = t42;
    $[110] = t43;
  } else {
    t43 = $[110];
  }
  let t44;
  if ($[111] !== t) {
    t44 = t("dashboard.actions.title.deactivate");
    $[111] = t;
    $[112] = t44;
  } else {
    t44 = $[112];
  }
  let t45;
  if ($[113] !== onActivateCourseBundle || $[114] !== t) {
    t45 = (opened_0, onClose_0, courseBundle_9, key_0) => <Confirmation key={key_0} opened={opened_0} onClose={onClose_0} onConfirm={() => onActivateCourseBundle(courseBundle_9)} confirmationText={t("dashboard.actions.activate_confirmation", {
      activate: t("global.deactivate").toLowerCase().toLowerCase(),
      module: t("dashboard.course_bundle.title_one").toLowerCase()
    })} toastCaption={t("dashboard.actions.activated", {
      module: t("dashboard.course_bundle.title_one"),
      activated: t("dashboard.actions.deactivated_caption").toLowerCase()
    })} />;
    $[113] = onActivateCourseBundle;
    $[114] = t;
    $[115] = t45;
  } else {
    t45 = $[115];
  }
  let t46;
  if ($[116] !== t44 || $[117] !== t45) {
    t46 = {
      name: "deactivate-course-bundle",
      shouldRender: _temp5,
      caption: t44,
      onActionRender: t45
    };
    $[116] = t44;
    $[117] = t45;
    $[118] = t46;
  } else {
    t46 = $[118];
  }
  let t47;
  if ($[119] !== t43 || $[120] !== t46) {
    t47 = [t43, t46];
    $[119] = t43;
    $[120] = t46;
    $[121] = t47;
  } else {
    t47 = $[121];
  }
  let t48;
  if ($[122] !== onRemoveCourseBundle) {
    t48 = {
      onChange: courseBundle_10 => onRemoveCourseBundle(courseBundle_10)
    };
    $[122] = onRemoveCourseBundle;
    $[123] = t48;
  } else {
    t48 = $[123];
  }
  let t49;
  if ($[124] !== t40 || $[125] !== t47 || $[126] !== t48) {
    t49 = {
      openLink: t33,
      settings: t40,
      custom: t47,
      remove: t48
    };
    $[124] = t40;
    $[125] = t47;
    $[126] = t48;
    $[127] = t49;
  } else {
    t49 = $[127];
  }
  let t50;
  if ($[128] !== columns || $[129] !== courseBundles || $[130] !== t30 || $[131] !== t31 || $[132] !== t32 || $[133] !== t49) {
    t50 = <Table caption={t30} data={courseBundles} columns={columns} limiter={t31} paginator={t32} actions={t49} />;
    $[128] = columns;
    $[129] = courseBundles;
    $[130] = t30;
    $[131] = t31;
    $[132] = t32;
    $[133] = t49;
    $[134] = t50;
  } else {
    t50 = $[134];
  }
  let t51;
  if ($[135] !== counter || $[136] !== courseBundles || $[137] !== t20 || $[138] !== t29 || $[139] !== t50) {
    t51 = <>{t18}<ListingLayout data={courseBundles} counter={counter} title={t20} createData={t29} type="compact">{t50}</ListingLayout></>;
    $[135] = counter;
    $[136] = courseBundles;
    $[137] = t20;
    $[138] = t29;
    $[139] = t50;
    $[140] = t51;
  } else {
    t51 = $[140];
  }
  return t51;
};
export const getServerSideProps = getCombinedServerSideProps(getBaseServerSideProps(CourseBundlesLoco, 'header.top_menu.course_bundles'), getServerSideFlagsProps());
export default CourseBundles;
function _temp(courseBundle) {
  return <div className="truncate"><LinkWithoutPrefetch rel="noreferrer" className="text-brand-primary hover:text-text-secondary ring-brand-primary rounded-xs w-full outline-hidden ring-offset-1 focus-visible:ring-2" href={`/courses/bundles/${courseBundle.id}`}>{courseBundle.name}</LinkWithoutPrefetch></div>;
}
function _temp2(t0) {
  const {
    image
  } = t0;
  return image && <img className="h-[108px] w-[192px] object-contain" alt={image.filename} src={image.path} />;
}
function _temp3(courseBundle_4) {
  return `/courses/bundles/${courseBundle_4.id}`;
}
function _temp4(courseBundle_6) {
  return !!courseBundle_6.deactivatedAt;
}
function _temp5(courseBundle_8) {
  return !courseBundle_8.deactivatedAt;
}